<div id="home-v2" class="home-v2">
  <app-home-header></app-home-header>
  <app-home-hero (personaChange)="onHeroPersonaChange($event)"></app-home-hero>

  <div class="home-v2__vigilado-anchor" aria-hidden="true">
    <img class="home-v2__vigilado-side" src="assets/img/Home/hero/Ico_super.svg" alt="" />
  </div>

  <app-home-valor></app-home-valor>
  <app-home-pasos></app-home-pasos>
  <app-home-aliados></app-home-aliados>
  <app-home-cuenta [perfilInicial]="heroPersonaType" (perfilChange)="heroPersonaType = $event"></app-home-cuenta>
  <app-home-datos></app-home-datos>
  <app-home-testimonios></app-home-testimonios>
  <app-home-para-mi></app-home-para-mi>
  <app-home-faq></app-home-faq>
  <app-home-cta-final></app-home-cta-final>
  <app-home-site-footer></app-home-site-footer>
</div>